import React, { useEffect, useState } from "react";
import { Navbar } from "../components/landing/Navbar";
import { HeroSection } from "../components/landing/HeroSection";
import { ServicesSection } from "../components/landing/MainSections";
import { ProductCatalogLive } from "../components/landing/ProductCatalogLive";
import { TestimonialsLive } from "../components/landing/TestimonialsLive";
import { ContactFormSection } from "../components/landing/ContactFormSection";
import {
  PaymentSection,
  FooterSection,
  WhatsAppFloatingButton,
} from "../components/landing/BottomSections";
import { publicApi } from "../lib/api";

export default function LandingPage() {
  const [products, setProducts] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [siteContent, setSiteContent] = useState(null);

  useEffect(() => {
    publicApi.getProducts().then((r) => setProducts(r.data)).catch(console.error);
    publicApi.getTestimonials().then((r) => setTestimonials(r.data)).catch(console.error);
    publicApi.getSiteContent().then((r) => setSiteContent(r.data)).catch(console.error);
  }, []);

  return (
    <>
      <Navbar siteContent={siteContent} />
      <HeroSection siteContent={siteContent} />
      <ServicesSection />
      <ProductCatalogLive products={products} siteContent={siteContent} />
      <TestimonialsLive testimonials={testimonials} siteContent={siteContent} />
      <ContactFormSection />
      <PaymentSection />
      <FooterSection siteContent={siteContent} />
      <WhatsAppFloatingButton siteContent={siteContent} />
    </>
  );
}
